import { render, staticRenderFns } from "./ProjectCreate.vue?vue&type=template&id=da5b2fa4&scoped=true"
import script from "./ProjectCreate.vue?vue&type=script&lang=js"
export * from "./ProjectCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5b2fa4",
  null
  
)

export default component.exports